import { render, staticRenderFns } from "./EditDailyAnswers.vue?vue&type=template&id=05975c63&scoped=true&"
import script from "./EditDailyAnswers.vue?vue&type=script&lang=js&"
export * from "./EditDailyAnswers.vue?vue&type=script&lang=js&"
import style0 from "./EditDailyAnswers.vue?vue&type=style&index=0&id=05975c63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05975c63",
  null
  
)

export default component.exports